<template>
  <v-snackbar
    v-model="snackbar"
    :timeout="timeout"
    :color="color"
    location="top center"
    rounded="lg"
    elevation="10"
  >
  <div class="snackbarText">{{ message }}</div>
  </v-snackbar>
</template>

<script>
export default {
  name: 'SnackbarMessage',
  data() {
    return {
      snackbar: false,
      message: '',
      timeout: 2000,
      color: 'green',
    }
  },
  methods: {
    show(msg = 'Buchung erfolgreich', color = 'green', timeout = 3000) {
      this.message = msg
      this.color = color
      this.timeout = timeout
      this.snackbar = false // Reset to ensure retrigger
      this.$nextTick(() => {
        this.snackbar = true
      })
    }
  }
}
</script>

<style scoped>

.snackbarText {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

</style>